import styled from "@emotion/styled";
import { Button } from "@chakra-ui/react";
import { BsDownload as DownloadIcon} from "react-icons/bs";
import { BsUpload as UploadIcon} from "react-icons/bs";
import { useState } from "react";

type UploadType = {
    label:string;
    onChange?:Function;
    accept?:string;
    bg?:string;
}
const Container = (props:any) =>{
  return <label {...props}>{props.children}</label>
}


const ButtonFile =  styled(Container)`
  width:${(props:any) => props.width || 'fit-content'};
  overflow: hidden;
  position:relative;
  & > input{
    position: absolute;
    left:0;
    top:0;
    opacity:0;
    width:100%;
    height: 100%;
    z-index:1;
  }
  & > button{
    cursor: pointer;
    background-color: ${(props:any) => props.bg || 'var(--dark-green-color) !important'};
    color:${props => props.color || 'var(--white-color)'};
  }
`

const UploadButton = ({label,onChange,accept,bg}:UploadType) => {
    const [data,set_data] = useState({value:'',file:''})
    const tempChange = (e:any) =>{

        const value = e.target.value;
        const file = e.target.files[0];
        
        if(value && file && onChange){ 
          onChange(file);
          set_data({value,file});
        }
       // console.log(file,value,'file value')
    }
  return (
    <ButtonFile>
      <input type="file" value={data.value} onChange={(e:any) => tempChange(e)} accept={accept ||'image/*'} />
      <Button colorScheme={bg} type="button" leftIcon={<UploadIcon/>}>{label}</Button>
    </ButtonFile>
  )
}

export default UploadButton